<template>
  <router-view />
</template>
<!--import { provide,nextTick } from 'vue'-->
<script>
export default {
  name: "App",
  // const isRouterActive = ref(true)
  // provide('reload', () => {
  // isRouterActive.value = false
  // nextTick(() => {
  //   isRouterActive.value = true
  // })
  // })
};
</script>
<style>
#app {
  max-width: 750px;
  margin: auto;
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
}
</style>
